import {
  Button,
  Popconfirm,
  Tag,
  Space,
  List,
  Select,
  message,
  Row,
  Col,
  Typography,
  Spin,
} from "antd";

import {isValuable, toArray} from "helper/common";
import React, {
  SetStateAction,
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";

import Icons from "assets/icons";
import {exportFile} from "helper/common";

import {shoppingService} from "api";
import {ModalCustom, Notification} from "components/common";
import {RecycleSVG} from "assets";
import ModalUpload from "./ModalUpload/ModalUpload";

const UploadHoSo = forwardRef((props: any, ref) => {
  const {id, closeModal} = props;
  const [hoso1, setHoso1] = useState([]);
  const [hoso2, setHoso2] = useState([]);
  const [hoso3, setHoso3] = useState([]);
  const [hoso4, setHoso4] = useState([]);
  const modalRef = useRef(null);

  const [isLoading, setIsLoading] = useState(false);
  useImperativeHandle(ref, () => ({
    openModal: () => {
      modalRef?.current?.openModal();
    },
  }));
  useEffect(() => {
    if (isValuable(id)) {
      fetchAllFiles(id);
    } else {
      // setDanhSachHoSo([]);
      console.log("Do nothing");
    }
  }, [id]);

  const fetchAllFiles = async id => {
    setIsLoading(true);
    try {
      const responses = await Promise.all([
        shoppingService.getListFileHoSo({idDeNghi: id, fileType: 1}),
        shoppingService.getListFileHoSo({idDeNghi: id, fileType: 2}),
        shoppingService.getListFileHoSo({idDeNghi: id, fileType: 3}),
        shoppingService.getListFileHoSo({idDeNghi: id, fileType: 4}),
      ]);

      setHoso1(responses[0]);
      setHoso2(responses[1]);
      setHoso3(responses[2]);
      setHoso4(responses[3]);
    } catch (error) {
      console.error("Error fetching list files:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDownloadFile = async tenFile => {
    try {
      await exportFile(
        "qlttbhyt-service/download-files",
        {file: tenFile},
        tenFile,
        "pdf"
      );
    } catch (error) {
      Notification("error", error?.response?.data ?? "Có lỗi khi tải hồ sơ");
    }
  };

  const handleDelete = async tenFile => {
    try {
      setIsLoading(true);
      await shoppingService.deleteHoSo(tenFile);
      Notification("success", "Xóa hồ sơ thành công");
      fetchAllFiles(id);
    } catch (error) {
      console.error("Delete failed:", error);
      Notification("error", "Có lỗi khi xóa file");
    } finally {
      setIsLoading(false);
    }
  };

  const renderHoSoList = (data, label, color) => (
    <List
      loading={isLoading}
      size="small"
      bordered
      dataSource={data}
      renderItem={(item: any) => (
        <List.Item>
          <Row justify={"space-between"} gutter={[4, 4]}>
            <Col span={21}>
              <Tag color={color}>{label}</Tag>
              <Typography.Link
                onClick={() => handleDownloadFile(item?.tenFile)}
              >
                {item?.name}
              </Typography.Link>
            </Col>
            <Col span={3}>
              <Popconfirm
                title="Xác nhận xóa?"
                onConfirm={() => handleDelete(item?.tenFile)}
                okText="OK"
                cancelText="Hủy"
              >
                <Button danger icon={<RecycleSVG />} />
              </Popconfirm>
            </Col>
          </Row>
        </List.Item>
      )}
    />
  );

  return (
    <div>
      <Spin spinning={isLoading}>
        <Row gutter={[4, 4]}>
          {toArray(hoso1)?.length > 0 && (
            <Col span={6}>{renderHoSoList(hoso1, "Hóa đơn", "magenta")}</Col>
          )}
          {toArray(hoso2)?.length > 0 && (
            <Col span={6}>{renderHoSoList(hoso2, "Hợp đồng", "volcano")}</Col>
          )}

          {toArray(hoso3)?.length > 0 && (
            <Col span={6}>
              {renderHoSoList(hoso3, "Biên bản giao nhận", "geekblue")}
            </Col>
          )}
          {toArray(hoso4)?.length > 0 && (
            <Col span={6}>{renderHoSoList(hoso4, "Chứng từ khác", "cyan")}</Col>
          )}
        </Row>
      </Spin>

      <ModalCustom title="Tải hồ sơ" ref={modalRef} width={600}>
        <ModalUpload fetchAllFiles={fetchAllFiles} id={id}></ModalUpload>
      </ModalCustom>
    </div>
  );
});

export default UploadHoSo;
